import { toast } from "react-toastify";
import React from "react";

export const errorToast = (message: string) => {
    toast.error(message, {
        icon: (
            <i
                className="pi pi-exclamation-triangle"
                style={{
                    color: "var(--toastify-icon-color-error)",
                    fontSize: "1em"
                }}
            ></i>
        )
    });
};

export const warningToast = (message: string) => {
    toast.warn(message, {
        icon: (
            <i
                className="pi pi-exclamation-triangle"
                style={{
                    color: "var(--toastify-icon-color-warning)",
                    fontSize: "1em"
                }}
            ></i>
        )
    });
};

export const successToast = (message: string) => {
    toast.success(message, {
        icon: (
            <i
                className="pi pi-check"
                style={{
                    color: "var(--toastify-icon-color-success)",
                    fontSize: "1em"
                }}
            ></i>
        )
    });
};

export const infoToast = (message: string) => {
    toast.info(message, {
        icon: (
            <i
                className="pi pi-info-circle"
                style={{
                    color: "var(--toastify-icon-color-info)",
                    fontSize: "1em"
                }}
            ></i>
        )
    });
};
